import { throttle } from 'lodash';
var entries = new Set();
var container = null;
var onScroll = null;
var attached = false;
function enterLeaveTops() {
    var enterTop = window.innerWidth > 1000 ? 78 : 110;
    return { enterTop: enterTop, leaveTop: enterTop + 40 };
}
function handleScroll() {
    var _a = enterLeaveTops(), enterTop = _a.enterTop, leaveTop = _a.leaveTop;
    entries.forEach(function (entry) {
        var _a;
        var el = entry.getElement();
        if (!el) {
            return;
        }
        var stickyCb = entry.onSticky;
        if (!stickyCb) {
            return;
        }
        var y = el.getBoundingClientRect().top;
        var currentlySticky = entry.isSticky();
        if (!currentlySticky && y <= enterTop) {
            entry.setSticky(true);
            stickyCb(entry.getTitle());
        }
        else if (currentlySticky && y > leaveTop) {
            entry.setSticky(false);
            (_a = entry.onUnSticky) === null || _a === void 0 ? void 0 : _a.call(entry, entry.getTitle());
        }
    });
}
function ensureListener() {
    var next = document.getElementById('sticky-container');
    if (!next) {
        return;
    }
    if (attached && container === next) {
        return;
    }
    detachListener();
    container = next;
    onScroll = throttle(handleScroll, 100);
    container.addEventListener('scroll', onScroll, { passive: true });
    attached = true;
}
function detachListener() {
    if (container && onScroll) {
        var throttled = onScroll;
        if (throttled.cancel) {
            throttled.cancel();
        }
        container.removeEventListener('scroll', onScroll);
    }
    container = null;
    onScroll = null;
    attached = false;
}
/** Register a sticky category header. One shared scroll listener on #sticky-container. */
export function registerStickyHeader(entry) {
    entries.add(entry);
    ensureListener();
    // Evaluate once in case the header mounts already past the threshold.
    handleScroll();
    return function () {
        entries.delete(entry);
        if (entries.size === 0) {
            detachListener();
        }
    };
}
//# sourceMappingURL=stickyScrollRegistry.js.map